import React from "react";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = ({ isActive, ...rest }) => {
  return isActive ? (
    <svg xmlns="http://www.w3.org/2000/svg" {...rest} width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path
        d="M3.54419 11.4754C3.54419 8.96127 3.54419 7.70419 4.32524 6.92314C5.10629 6.14209 6.36337 6.14209 8.87752 6.14209H16.8775C19.3917 6.14209 20.6488 6.14209 21.4298 6.92314C22.2109 7.70419 22.2109 8.96127 22.2109 11.4754V12.8088C22.2109 15.3229 22.2109 16.58 21.4298 17.361C20.6488 18.1421 19.3917 18.1421 16.8775 18.1421H8.87752C6.36337 18.1421 5.10629 18.1421 4.32524 17.361C3.54419 16.58 3.54419 15.3229 3.54419 12.8088V11.4754Z"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M22.2109 -1.19141V-0.52474C22.2109 1.31621 20.7185 2.80859 18.8775 2.80859H6.87752C5.03657 2.80859 3.54419 1.31621 3.54419 -0.52474V-1.19141"
        stroke="#F59C53"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M22.2109 25.4756V24.8089C22.2109 22.968 20.7185 21.4756 18.8775 21.4756H6.87752C5.03657 21.4756 3.54419 22.968 3.54419 24.8089V25.4756"
        stroke="#F59C53"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" {...rest} width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path
        d="M3.54419 11.4754C3.54419 8.96127 3.54419 7.70419 4.32524 6.92314C5.10629 6.14209 6.36337 6.14209 8.87752 6.14209H16.8775C19.3917 6.14209 20.6488 6.14209 21.4298 6.92314C22.2109 7.70419 22.2109 8.96127 22.2109 11.4754V12.8088C22.2109 15.3229 22.2109 16.58 21.4298 17.361C20.6488 18.1421 19.3917 18.1421 16.8775 18.1421H8.87752C6.36337 18.1421 5.10629 18.1421 4.32524 17.361C3.54419 16.58 3.54419 15.3229 3.54419 12.8088V11.4754Z"
        stroke="white"
        strokeWidth="2"
      />
      <path
        opacity="0.5"
        d="M22.2109 -1.19141V-0.52474C22.2109 1.31621 20.7185 2.80859 18.8775 2.80859H6.87752C5.03657 2.80859 3.54419 1.31621 3.54419 -0.52474V-1.19141"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        opacity="0.5"
        d="M22.2109 25.4756V24.8089C22.2109 22.968 20.7185 21.4756 18.8775 21.4756H6.87752C5.03657 21.4756 3.54419 22.968 3.54419 24.8089V25.4756"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Icon;
